import React, { useContext, useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';
import useFetch from '../../../../../hooks/shared/custom/data/geniatech/useFetch';
import { LEGACY_GENIATECH_URL } from '../../../../../services/api/shared/installations/InstallationsUrl';
import AppContext from '../../../../../context/shared/AppContext';

const MailBlastBasestationCustomersFilter = () => {
  const {
    onChange,
    onSubmit,
    handleChange,
    handleAccessPointChange: contextHandleAPChange,
    selectedBasestations,
    selectedAccessPoints,
  } = useContext(AppContext);
  const { data, loading } = useFetch(`${LEGACY_GENIATECH_URL}`, { action: 'fetch_basestations_list' });

  const [options, setOptions] = useState([]);
  const [accessPointsOptions, setAccessPointsOptions] = useState([]);
  const [accessPointsLoading, setAccessPointsLoading] = useState(false);

  useEffect(() => {
    if (data && data.items && data.items.length) {
      setOptions(
        data.items.map((el) => ({
          value: el,
          label: el,
        })),
      );
    }
  }, [data]);

  // Fetch access points whenever basestations change
  useEffect(() => {
    const fetchAccessPoints = async () => {
      if (!selectedBasestations.length) {
        setAccessPointsOptions([]);
        return;
      }

      setAccessPointsLoading(true);
      try {
        const response = await axios.post(
          'https://api.tizeti.com/api/v1/callstation/access_points',
          { calledstation: selectedBasestations.map(opt => opt.value) },
          { headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` } }
        );

        if (response.data && response.data.length) {
          const opts = response.data.map(ap => ({ value: ap.id, label: ap.name }));
          setAccessPointsOptions(opts);
        }
      } catch (error) {
        console.error('Error fetching access points:', error);
      } finally {
        setAccessPointsLoading(false);
      }
    };

    fetchAccessPoints();
  }, [selectedBasestations]);

  return (
    <div className="p-0">
      <div className="col-12 d-flex">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="form-inline ml-3"
        >
          <div className="form-group">
            {loading || accessPointsLoading ? (
              <Button variant="primary" disabled>
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                Fetching Data...
              </Button>
            ) : (
              <>
                <p className="select-p">Select Basestation</p>
                <Select
                  onChange={handleChange}
                  value={selectedBasestations}
                  isMulti
                  name="basestations"
                  options={options}
                  className="basic-multi-select select-options"
                />

                <p className="select-p">Select Access Point</p>
                <Select
                  onChange={contextHandleAPChange}
                  value={selectedAccessPoints}
                  isMulti
                  name="accesspoints"
                  options={accessPointsOptions}
                  className="basic-multi-select select-options"
                />
              </>
            )}
          </div>
          <div className="form-group">
            <select name="type" onChange={onChange} className="form-control">
              <option value="">--Filter By--</option>
              <option value="active">Active Customers</option>
              <option value="inactive">Inactive Customers</option>
            </select>
          </div>
          <div className="form-group mx-2">
            <button className="btn btn-green" type="submit">
              Search
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MailBlastBasestationCustomersFilter;
